// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 22H22V2H2V22ZM15.5 12L10 16.25V7.75L15.5 12Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chevron-right-rectangle-filled')
export default class ChevronRightRectangleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chevron-right-rectangle-filled',
    }
  }
}
